const REM_VALUE = 16;
export const pxToRemLiteral = (pxValue) => {
    let value = 0;
    if (typeof pxValue === 'string' && pxValue.includes('rem')) {
        return pxValue;
    }
    if (typeof pxValue === 'string' && pxValue.includes('px')) {
        value = parseInt(pxValue.replace('px', ''), 10);
    }
    else if (typeof pxValue === 'number' && pxValue) {
        value = pxValue;
    }
    if (value === 0) {
        return '0rem';
    }
    return `${value / REM_VALUE}rem`;
};
//# sourceMappingURL=pxToRemLiteral.js.map